module.exports = __webpack_public_path__ + "static/media/eclipse-alt.c7d1d288.svg";